import React from "react";

// Marks a survey done for a prospect (no customer record yet).
const NewCustomerTag = () => (
  <span className="badge ms-2 fw-semibold" style={{ background: "#FFF4E5", color: "#B0570B", fontSize: 10.5 }}>
    New customer
  </span>
);

export default NewCustomerTag;
